import * as React from "react";
import Svg, { Path } from "react-native-svg";

function SvgComponent(props) {
  return (
    <Svg
      width={13}
      height={14}
      viewBox="0 0 13 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <Path
        d="M.149 13.95c-.09-.071-.18-.147-.138-.286.042-.142.153-.181.286-.166.108.012.108-.045.108-.124-.003-.682 0-1.367 0-2.05 0-.365.141-.507.509-.507.52 0 1.041-.003 1.565.003.097 0 .13-.02.127-.123a7.283 7.283 0 01-.003-.514c.006-.283.16-.434.44-.437a97.24 97.24 0 011.625.003c.105 0 .135-.028.135-.133-.006-.341-.003-.683-.003-1.027.003-.305.16-.459.467-.459.536 0 1.072-.003 1.61.003.1 0 .124-.027.124-.123-.006-.52-.003-1.036-.003-1.555 0-.32.15-.471.467-.471.533 0 1.062-.003 1.595.003.118.003.139-.033.139-.142-.006-.682-.003-1.367-.003-2.05 0-.356.141-.498.5-.498h1.7c.296 0 .446.151.446.44 0 1.513 0 3.026.003 4.541 0 .166-.057.269-.22.305-.132.043-.195-.039-.243-.139-.052-.102-.046-.214-.046-.326V4.136v-.135c-.003-.188-.012-.197-.195-.2-.271-.003-.542.006-.813-.003-.16.01-.322.006-.482.003-.117 0-.165.049-.16.163.004.04 0 .082 0 .121v9.081c0 .287 0 .284.278.287.12 0 .24-.006.36.003.263-.01.522-.003.784-.003.222 0 .228-.003.228-.227V9.622c0-.112-.009-.224.051-.323.052-.09.115-.172.238-.121.184.051.217.1.217.317v3.87c0 .079-.012.151.111.136.124-.015.23.018.28.148.055.142-.039.22-.126.302H.149z"
        fill="#000"
        fillOpacity={0.5}
      />
      <Path
        d="M11.613 9.178c-.186.045-.234.109-.234.323v3.762c0 .235 0 .238-.235.235-.274 0-.551-.003-.825-.006-.072-.082-.048-.181-.048-.275V8.85 4.028c0-.094-.021-.194.048-.275.319-.003.641 0 .96-.01.133-.002.097.085.097.152v4.371c.003.196.045.25.234.314.003.2.003.399.003.598z"
        fill="#F2F2F2"
      />
      <Path
        d="M6.588 4.28v1.208c0 .343-.124.521-.362.512-.234-.005-.353-.184-.353-.532 0-.825-.005-1.656.005-2.482 0-.179-.038-.237-.22-.222-.228.02-.457.01-.69.005-.405-.015-.615-.392-.386-.73.42-.623.853-1.236 1.291-1.845.186-.256.53-.26.715-.004.448.613.886 1.231 1.306 1.864.214.323-.005.7-.391.715-.253.01-.51.01-.763 0-.128-.005-.162.038-.157.164.01.444.005.893.005 1.347z"
        fill="#000"
        fillOpacity={0.5}
      />
      <Path
        d="M8.124 6.44c.32-.003.642 0 .96-.006.082 0 .103.027.1.102-.003.248 0 .492 0 .74 0 2.02 0 4.04.003 6.062 0 .13-.024.172-.163.166-.3-.012-.602-.006-.9-.009-.054-.057-.048-.13-.048-.2V6.643c-.003-.072-.006-.145.048-.202z"
        fill="#F2F2F2"
      />
      <Path
        d="M10.319 3.753v9.74c-.196.002-.392 0-.587.005-.081.003-.109-.027-.1-.106.003-.024 0-.05 0-.075 0-3.13 0-6.261-.003-9.392 0-.142.028-.196.178-.184.172.018.343.009.512.012z"
        fill="#CCC"
      />
      <Path
        d="M6.98 8.607c.003.052.009.1.009.151 0 1.528-.003 3.056.003 4.58 0 .133-.033.17-.163.163-.3-.012-.602-.006-.9-.009-.054-.057-.048-.13-.048-.2 0-1.49-.003-2.985 0-4.476 0-.218.01-.227.232-.224.286.01.575-.015.867.015z"
        fill="#F2F2F2"
      />
      <Path
        d="M8.124 6.44v7.052c-.19.003-.38-.003-.569.006-.096.003-.117-.033-.114-.12.003-.426.003-.855.003-1.28 0-1.833 0-3.666-.003-5.498 0-.127.024-.181.162-.17.169.016.343.01.521.01z"
        fill="#CCC"
      />
      <Path
        d="M3.729 10.207c.322-.003.641-.003.963-.009.096-.003.103.046.103.121-.003.347 0 .694 0 1.042 0 .67-.003 1.337.003 2.007 0 .103-.025.14-.133.136-.31-.009-.62-.006-.933-.006-.054-.057-.048-.13-.048-.2V10.41c-.003-.073-.006-.145.045-.203z"
        fill="#F2F2F2"
      />
      <Path
        d="M6.98 8.607c-.295 0-.593.006-.888-.003-.133-.003-.169.034-.169.166.006 1.573.003 3.146.003 4.72-.18.002-.361-.007-.542.008-.126.01-.144-.042-.144-.154.003-1.443.003-2.883.003-4.326 0-.139-.06-.323.024-.408.09-.093.274-.027.418-.03.395-.006.792-.003 1.186-.003.037.006.082-.018.109.03z"
        fill="#CCC"
      />
      <Path
        d="M2.585 11.294c.027.215.009.432.012.646.003.477 0 .954.003 1.431 0 .09-.012.133-.12.13-.317-.009-.63-.006-.946-.009-.051-.051-.048-.118-.048-.184-.003-.607-.003-1.214 0-1.824 0-.199.012-.208.217-.205.292.006.587-.015.882.015z"
        fill="#F2F2F2"
      />
      <Path
        d="M3.729 10.207v3.285c-.196.003-.392 0-.584.006-.084.003-.1-.033-.1-.106.003-1.029.003-2.056 0-3.085 0-.072.016-.112.1-.109.196.006.388.006.584.01zM2.585 11.294c-.301 0-.603.006-.9 0-.118-.003-.154.03-.154.151.003.682.003 1.365.003 2.047-.196.003-.392 0-.587.006-.07.003-.097-.018-.097-.094.003-.679.003-1.358 0-2.037 0-.067.016-.103.09-.103.534.003 1.064 0 1.596 0 .021.003.04.01.049.03zM6.98 2H5.486c.25-.338.486-.654.746-1 .25.333.495.658.75 1z"
        fill="#CCC"
      />
    </Svg>
  );
}

export default SvgComponent;
